module.exports = __webpack_public_path__ + "static/media/milchkannen.f5b37516.jpg";